export enum SalesItemAttributeType {
  DataEntry = 1,
  YesNo = 2,
  List = 3,
  Barcode = 4,
  Rabies = 5,
  Refill = 6,
  InstructionLabel = 7,
  PrescriptionQuantity = 8,
}
